export enum ModalType {
  Notifications = 'Notifications',
  SignOut = 'SignOut',
  ViewChanges = 'ViewChanges',
}
